import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/auth/register/code/success/page";

export const Route = createFileRoute("/auth/register/code/success")({
  component: Page,
});
